var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockOpenFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 7.95c0-1.342 1.108-2.45 2.5-2.45s2.5 1.108 2.5 2.45v2.55a.75.75 0 001.5 0V7.95C20 5.757 18.198 4 16 4s-4 1.757-4 3.95V10H6a2 2 0 00-2 2v5.5a2 2 0 002 2h7a2 2 0 002-2V12a2 2 0 00-1.5-1.937V7.95zM6 11.5h7a.5.5 0 01.5.5v5.5a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V12a.5.5 0 01.5-.5z",
    fill: "currentColor"
  })));
}

export default SvgLockOpenFill;